<template>
  <div>
    <div v-if="isVerified">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.emailVerified') }}.</h1>
        <h2 class="is-size-6">{{ $t('description.canLoginWithEmailAndPassword') }}</h2>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <router-link class="button is-vcentered is-primary login-button" :to="{ name: 'login' }">
          <strong>{{ $t('button.login') }}</strong>
        </router-link>
      </div>
    </div>
    <div v-else-if="isVerified === false">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.emailNotVerified') }}</h1>
        <h2 class="is-size-6">{{ $t('description.pleaseTryAgain') }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../_api/api.service'

export default {
  data() {
    return {
      isVerified: null
    }
  },
  mounted() {
    const { token } = this.$route.query
    if (!token) {
      this.$router.push({ name: 'login' })
    } else {
      ApiService.post('/auth/verify', { token }, { silent: true })
        .then(data => {
          this.isVerified = data.isValid
          this.forgetToken()
        })
        // A link the API does not know was used already: an unverified user's links all work
        // until one of them, or a password reset, verifies the account. So the account is
        // verified and the page says so. A mangled link lands here too; its login then sends
        // the user a new link. Only a failed request leaves the account's state unknown
        .catch(error => {
          this.isVerified = !!(error.response && error.response.status === 400)
          if (this.isVerified) this.forgetToken()
        })
    }
  },
  methods: {
    forgetToken() {
      // the used token leaves the address bar, so later page views and links don't carry
      // it. Not through the router: it reloads the page when the route stays the same.
      // A user who left before the answer keeps the query of the page they are on
      if (this.$route.name === 'verifyEmail') {
        window.history.replaceState(
          window.history.state,
          '',
          window.location.pathname
        )
      }
    }
  }
}
</script>
